import { render, staticRenderFns } from "./user-editor.vue?vue&type=template&id=56d11c13&scoped=true&"
import script from "./user-editor.vue?vue&type=script&lang=ts&"
export * from "./user-editor.vue?vue&type=script&lang=ts&"
import style0 from "./user-editor.vue?vue&type=style&index=0&id=56d11c13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d11c13",
  null
  
)

export default component.exports